import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

// components
import { CButton, CImage } from '@coreui/react-pro'
import AppCard from '../../components/AppCard'
import AppTable from 'src/components/AppTable'
import AppModalConfirmation from 'src/components/modal/AppModalConfirmation'

// icons
import AddMoreIconWhite from '../../assets/icons/AddMoreIconWhite.png'

// styling
import { styleButtonVars2 } from '../../components/custom-styles/buttonStyles'

// helpers
import Axios from '../../helpers/axios'
import { columnAssetList } from '../../components/table-column/TableColumnList'
import { formUrlQuery } from '../../helpers/format-queries'
import useToastMessage from 'src/helpers/toast-message'

const AssetList = () => {
  const navigate = useNavigate()
  const { showSuccess, showError } = useToastMessage();

  const [showConfirmDelete, setShowConfirmDelete] = useState({ show: false, item: {} })

  const [assetList, setAssetList] = useState([]);
  const [assetListCount, setAssetListCount] = useState(0);
  const [assetListPerPage, setAssetListPerPage] = useState(10);
  const [activeAssetListPage, setActiveAssetListPage] = useState(1);
  const [searchAssetListFilter, setSearchAssetListFilter] = useState("");
  const [columnAssetListSorter, setColumnAssetListSorter] = useState({ column: "updatedAt", state: "desc" });

  useEffect(() => {
    let queries = {
      search: searchAssetListFilter,
      limit: assetListPerPage,
      offset: assetListPerPage * activeAssetListPage - assetListPerPage,
      sort:
        (columnAssetListSorter &&
          `${columnAssetListSorter.column}%${columnAssetListSorter.state}`) ||
        "",
    };
    queries = formUrlQuery(queries);
    fetchAllAssets(queries);
  }, [
    searchAssetListFilter,
    assetListPerPage,
    activeAssetListPage,
    columnAssetListSorter,
  ]);

  const handleSearchItems = (search) => {
    setActiveAssetListPage(1)
    setSearchAssetListFilter(search);
  }

  const fetchAllAssets = (queries) => {
    Axios({
      method: "get",
      url: `/api/tracker/v1/asset?${queries}`
    })
      .then(({ data }) => {
        const tempAssetList = data?.value
        setAssetList(tempAssetList);
        if (activeAssetListPage === 1) {
          setAssetListCount(data?.count);
        }
      })
      .catch((err) => {
        console.error(err);
        const errMsg = err?.response?.data?.message
        showError(errMsg)
      });
  };

  const handleDeleteConfirmation = () => {
    Axios({
      method: "delete",
      url: `/api/tracker/v1/asset/delete/${showConfirmDelete?.item?.id}`,
    })
      .then(({ data }) => {
        if (data?.success) {
          setShowConfirmDelete({ show: false, item: {} })
          fetchAllAssets()
          showSuccess('Asset has been successfully deleted')
          window.location.reload()
        }
      })
      .catch((err) => {
        console.error(err);
        const errMsg = err?.response?.data?.message
        showError(errMsg)
      });
  }

  const handleOnRowClick = (item, columnName) => {
    if (columnName !== 'action') {
      navigate(`/asset/details/${item.id}`)
    }
  }

  return (
    <>
      {
        showConfirmDelete?.show && (
          <AppModalConfirmation 
            confirmationType='delete-item'
            itemName={`Asset ${showConfirmDelete?.item?.name}`}
            itemDetails={showConfirmDelete.item}
            itemType={showConfirmDelete.type}
            itemIndex={showConfirmDelete?.index}
            showModal={showConfirmDelete}
            setShowModal={setShowConfirmDelete}
            handleConfirmation={handleDeleteConfirmation}
          />
        )
      }
      <div className='d-grid gap-2 d-flex justify-content-end mb-3'>
        <CButton style={styleButtonVars2} onClick={() => navigate('/asset/add')}>
          <CImage fluid src={AddMoreIconWhite} className='me-2' />
          Add Asset
        </CButton>
      </div>
      <AppCard 
        className='mb-4'
        headerTitle={<h4>Asset List</h4>}
        bodyContent={
          <AppTable
            assetListPage
            tableFilter
            setShowConfirmDelete={setShowConfirmDelete}
            tableColumns={columnAssetList}
            tableContent={assetList}
            contentPerPage={assetListPerPage}
            activeContentPage={activeAssetListPage}
            contentCount={assetListCount}
            searchContentFilter={searchAssetListFilter}
            setActiveContentPage={setActiveAssetListPage}
            setSearchContentFilter={handleSearchItems}
            setContentPerPage={setAssetListPerPage}
            setColumnContentSorter={setColumnAssetListSorter}
            handleOnRowClick={handleOnRowClick}
            isClickable={true}
          />
        }
      />
    </>
  )
}

export default AssetList